import React from 'react';
import { CheckCircle, XCircle, EyeOff, Ban, Eye } from 'lucide-react';
import { FindingStatus } from '../../types/finding';
import { Badge } from '../../design-system';
import { FINDING_STATUS_TONE, FINDING_STATUS_LABEL } from '../../design-system/severity';

interface FindingStatusBadgeProps {
  status: FindingStatus;
}

const ICON: Record<FindingStatus, React.ElementType> = {
  open: XCircle,
  resolved: CheckCircle,
  ignored: EyeOff,
  false_positive: Ban,
  needs_manual_review: Eye,
};

/** Finding-status pill (icon + label) — colours come from the design-system Badge tones. */
const FindingStatusBadge: React.FC<FindingStatusBadgeProps> = ({ status }) => {
  const Icon = ICON[status] || XCircle;
  return (
    <Badge tone={FINDING_STATUS_TONE[status]} size="md" icon={<Icon className="w-3.5 h-3.5" />}>
      {FINDING_STATUS_LABEL[status]}
    </Badge>
  );
};

export default FindingStatusBadge;
